import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import isoWeek from 'dayjs/plugin/isoWeek';
import customParseFormat from 'dayjs/plugin/customParseFormat.js';

import isBetween from 'dayjs/plugin/isBetween';

export const initializeDayJS = () => {
  // Extend dayjs with used plugins
  dayjs.extend(customParseFormat);
  dayjs.extend(isBetween);
  dayjs.extend(utc);
  dayjs.extend(weekOfYear);
  dayjs.extend(isoWeek);
};
